var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-card",
        { staticClass: "card-collapse", attrs: { shadow: "hover" } },
        [
          _c("app-header-dados-processo", {
            attrs: {
              processo: _vm.processo,
              isCCR: _vm.isCCR,
              dadosCadastros: _vm.dadosCadastros
            }
          })
        ],
        1
      ),
      _c(
        "el-card",
        { staticClass: "card-container", attrs: { shadow: "hover" } },
        [
          _c(
            "div",
            [
              _c(
                "el-steps",
                {
                  staticClass: "card-container",
                  attrs: {
                    active: _vm.active,
                    "finish-status": "success",
                    simple: "simple"
                  }
                },
                [
                  _c("el-step", { attrs: { title: "Informar dados do VTN" } }),
                  _c("el-step", { attrs: { title: "Confirmar dados VTN" } })
                ],
                1
              ),
              _vm.active === 0
                ? _c(
                    "validation-observer",
                    { ref: "validation", attrs: { tag: "div" } },
                    [
                      _vm.active === 0
                        ? _c(
                            "div",
                            [
                              _vm.isRoraima
                                ? _c("InformarDadosRR", {
                                    attrs: {
                                      vtnRequest: _vm.vtnRequest,
                                      municipios: _vm.municipiosRR
                                    },
                                    on: {
                                      calculaModuloFiscal:
                                        _vm.calculaModuloFiscal
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          )
                        : _vm._e()
                    ]
                  )
                : _vm._e(),
              _vm.active === 1
                ? _c(
                    "div",
                    [
                      !_vm.isRoraima
                        ? _c("ConfirmarDados", {
                            attrs: { dadosVtn: _vm.dadosVtn }
                          })
                        : _vm._e(),
                      _vm.isRoraima
                        ? _c("ConfirmarDadosRR", {
                            attrs: {
                              dadosVtn: _vm.dadosVtn,
                              cadastro: _vm.json
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e(),
              _c("app-buttons-cadastro", {
                attrs: {
                  showButtonCancelar: true,
                  showButtonProximo: !_vm.isUltimoPasso,
                  isUltimoPasso: _vm.isUltimoPasso,
                  isPrimeiroPasso: _vm.isPrimeiroPasso
                },
                on: {
                  proximo: _vm.proximo,
                  voltar: _vm.voltar,
                  cancelar: _vm.cancelar,
                  finalizar: _vm.finalizar
                }
              })
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2a1f1335", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2a1f1335","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/analise/vtn/CadastrarVtnRR.vue
// module id = null
// module chunks = 